export default {
    SET_TICKET_TRANSFERS(state, ticketTransfers) {
        state.ticketTransfers = ticketTransfers
    },
    ADD_TICKET_TRANSFER(state, ticketTransfer) {
        state.ticketTransfers.unshift(ticketTransfer)
    },
    ADD_NOTIFICATION_TRANSFER(state, notification) {
        let ticketTransferFiltred  = state.ticketTransferNotifications.filter((i) =>  {
            return i.id != notification.id
        })
        ticketTransferFiltred.unshift(notification)
        state.ticketTransferNotifications = ticketTransferFiltred;
    },
    CLEAR_NOTIFICATION_TRANSFER(state) {
        state.ticketTransferNotifications = []
    },
    CLEAR_NOTIFICATION_TRANSFER_BY_ID(state, id) {        
        setTimeout(() => {
            let newList = state.ticketTransferNotifications.filter(function(item) {
                return (item.id) !== (id)
            })
            
            state.ticketTransferNotifications = newList
        }, 300)
    }
}
